
import { Object3D, Object3DEventMap } from "three";

import { isProductMeshUserData, ProductMeshUserData } from "../interfaces/ProductMeshUserData";
import { ElementTypeEnum } from "../elementTypeMappings";
import ProductData from "../model/productData/ProductData";


function getParentProductMeshUserData (object: Object3D): ProductMeshUserData | null {
    const parent = getParentThreeProduct(object);
    return parent && isProductMeshUserData(parent?.userData)
            ? parent.userData as ProductMeshUserData
            : null;
};

function getParentProductData<T extends ProductData> (object: Object3D): T | null {
    const parentMeshUserData = getParentProductMeshUserData(object);
    return parentMeshUserData 
            ? parentMeshUserData.product.productData as T 
            : null;
};

function getParentThreeSpace(object: Object3D): Object3D | null {
    const parent = getParentThreeProduct(object);
    const parentUserData = parent?.userData as ProductMeshUserData;
    if (parentUserData?.product.productData.productType === ElementTypeEnum.Space)
        return parent;

    return null;
}

// Finds the nearest parent Object3D that has userData of type ProductMeshUserData
function getParentThreeProduct(object: Object3D): Object3D | null {
    return getParentThreeObjectByCondition(object, (parent) => (parent.userData as ProductMeshUserData) !== undefined);
}

const getParentThreeProductByType = (object3d: Object3D, parentType: ElementTypeEnum) : Object3D | null  => {
    
    const parent = getParentThreeObjectByCondition(object3d, (parent) => {
        if (isProductMeshUserData(parent.userData)) {
            const parentUserData = parent.userData as ProductMeshUserData;
            return parentUserData?.product.productData.productType === parentType
        }
        else {
            return false;
        }
        return false;
    });

    return parent;  
};

function getParentThreeObjectByCondition(object: Object3D, condition: (parent: Object3D) => boolean): Object3D | null {
    let parent = object.parent;
  
    while (parent) {
      if (condition(parent)) {
        return parent;
      }
      parent = parent.parent;
    }
  
    return null; // No parent satisfying the condition found
  }

export { getParentThreeProduct, getParentProductMeshUserData, getParentThreeProductByType };